import { Shipment } from '../models/shipment';
import { ShipmentStatusEnum } from '../enum/shipment-status.enum';
import { emptyCard } from './empty-card';
import { emptyQuote } from './empty-quote';
import { emptyPickup } from './empty-pickup';
import { PaymentOptionEnum } from '../enum/payment-option.enum';
import { SignatureOptionEnum } from '../enum/signature-option.enum';
import { PackagingTypeEnum } from '../enum/packaging-type.enum';
import { emptyCustoms } from './empty-customs';

export const emptyShipment: Shipment = {
    id: '',
    number: '',
    username: '',
    organizationId: null,
    shipper: emptyCard,
    destination: emptyCard,
    soldTo: emptyCard,
    broker: emptyCard,
    trackingNumber: '',
    createdAt: '',
    shipmentDate: '',
    statusCode: ShipmentStatusEnum.QUOTE,
    dimensionUnit: '',
    weightUnit: 'KG',
    currency: 'USD',
    documentsOnly: false,
    packagingType: PackagingTypeEnum.CUSTOMER_PACKAGING,
    deliveryDate: '',
    deliveryTime: '',
    deliverySignature: '',
    paymentOption: PaymentOptionEnum.ACCOUNT,
    paymentAccountNumber: '',
    notifyShipper: false,
    notifyDestination: false,
    tracking: null,
    quotes: [],
    packages: [],
    statusText: '',
    statusTimestamp: '',
    quote: emptyQuote,
    preSelectedQuoteId: null,
    pickupRequired: false,
    pickupBooked: false,
    pickup: emptyPickup,
    signatureOption: SignatureOptionEnum.DEFAULT,
    courierOptions: [],
    courierForms: [],
    references: [],
    documents: [],
    allowedPickupActions: [],
    quoteMode: null,
    customs: emptyCustoms,
    insuranceProvisionId: null
};
